import script from './SdsCarousel.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsBaseCarousel',{attrs:{"items":_vm.items,"isLoading":_vm.isLoading,"title":_vm.title,"showEdgeOffset":_vm.options.showEdgeOffset,"showEdgeEffect":_vm.options.showEdgeEffect,"edgeEffectVariant":_vm.options.edgeEffectVariant,"showNavigator":_vm.options.showNavigator,"navigatorVariant":_vm.options.navigatorVariant,"showIndicator":_vm.options.showIndicator,"indicatorVariant":_vm.options.indicatorVariant,"partiallyVisibleVariant":_vm.options.partiallyVisibleVariant,"scrollSnap":_vm.options.scrollSnap,"expandOnlyItem":_vm.options.expandOnlyItem,"layoutVariant":_vm.activeLayoutVariant,"responsiveLayoutVariant":_vm.activeResponsiveLayoutVariant,"mobileOptions":_vm.mobileOptions,"dataTestId":_vm.dataTestId},on:{"slideChanged":function($event){return _vm.$emit('slideChanged', $event )},"navigatorPreviousClick":function($event){return _vm.$emit('navigatorPreviousClick', $event )},"navigatorNextClick":function($event){return _vm.$emit('navigatorNextClick', $event )},"indicatorClick":function($event){return _vm.$emit('indicatorClick', $event )},"scrollPrevious":function($event){return _vm.$emit('scrollPrevious', $event )},"scrollNext":function($event){return _vm.$emit('scrollNext', $event )},"hover":function($event){return _vm.$emit('hover', $event )},"focusWithin":function($event){return _vm.$emit('focusWithin', $event )},"itemClick":function($event){return _vm.$emit('itemClick', $event )},"itemHover":function($event){return _vm.$emit('itemHover', $event )},"itemFocusWithin":function($event){return _vm.$emit('itemFocusWithin', $event )}},scopedSlots:_vm._u([_vm._l((_vm.SdsBaseCarouselSlots),function(slotName){return {key:slotName,fn:function(slotProps){return [_vm._t(slotName,null,null,slotProps)]}}})],null,true)})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
